import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 3h18v2H3z"
}), 'Maximize');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Maximize.js
// module id = 4786
// module chunks = 2